import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import { deepCopy } from '../../../../../../common/services/common.service';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import ChannelComponent from '../components/channel.component';
import { channel } from '../../../../../../redux/channel/action';
import { selectChannelQueryItems } from '../../../../../../redux/channel/selector';
let currentChange: any = {}

const ManagementChannel = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [
    channelBanner,
    setChannelBanner
  ] = useState<any>([])
  const [
    openFile,
    setOpenFile
  ] = useState<any>([]);
  const [
    openBannerFile,
    setOpenBannerFile
  ] = useState<any>([]);
  const storeItems = useSelector(selectStoresListItems)
  const parmas: any = useParams()
  const channelsQuery = useSelector(selectChannelQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true) 
const [
    selectedChannel,
    setSelectedChannel
  ] = useState({
    QRCodeMapping: {
      OwnerId: 0,
      OwnerTypeId: 0
    },
    Configurations: {
      ChannelBranding: {
        Primary: {},
        Secondary: {},
        Tertiary: {},
        Ghost: {}
      },
      ChannelBanners: [],
      ChannelLogo: {}
    }
  })

  const fetchChannelsQueryById= ()=>{
    dispatch(channel.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/channels/query`,entity:'channel',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedChannel({ ...selectedChannel, [field]: event })
  }
  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedChannel({ ...selectedChannel, [fields[0]]: value });
  }
  
  useEffect(
    () => {
       
            if (parmas?.id > 0) {
                fetchChannelsQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
         
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedChannel(channelsQuery?.result?.items)
        const currentSelectedChannelBanner = addNewChannelBannerRow({ selectedChannelBannerArg: channelsQuery?.result?.items?.Configurations?.ChannelBanners });
        setChannelBanner(currentSelectedChannelBanner)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    selectedChannel.Configurations.ChannelBanners = channelBanner
    selectedChannel.QRCodeMapping.OwnerId = parmas?.id
    selectedChannel.QRCodeMapping.OwnerTypeId = 133
      if (parmas?.id > 0) {
     dispatch(channel.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/channels`,entity:'channel',jsonData:{
          
    Records: [
        selectedChannel
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(channel.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/channels`,entity:'channel',jsonData:{
            
        Records: [
            selectedChannel
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
  const changeBannerImage = (idx: number, templateField: any, fileType: any) => {
    setOpenBannerFile({
        currentFileSrc: channelBanner[idx][templateField],
        folder: 'SalesChannel',
      type: fileType
    })
    currentChange = { idx, templateField }
  }
  const handleChannelBannerItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(channelBanner);// deep copy of grn items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setChannelBanner(items);
  }
  const addNewChannelBannerRow = ({ selectedChannelBannerArg }: any) => {
    const currentSelectedChannelBanner = deepCopy(selectedChannelBannerArg)
    const newSelectedChannelBannerRecord = {
      BannerImage: '',
      BannerMessage: '',
      BannerLabel: '',
      BannerLabelUrl: ''
    }
    if (currentSelectedChannelBanner.length === 0 ||
      currentSelectedChannelBanner[currentSelectedChannelBanner?.length - 1]?.BannerImage !== '' ||
      currentSelectedChannelBanner[currentSelectedChannelBanner?.length - 1]?.BannerMessage !== ''
    ) {
      currentSelectedChannelBanner?.push(newSelectedChannelBannerRecord)
    }
    return currentSelectedChannelBanner
  }
  const setCombinationInfo1 = async () => {
    let localSelectedChannelBanner = deepCopy(channelBanner)
    localSelectedChannelBanner.splice(
      currentChange.idx,
      1,
      { ...localSelectedChannelBanner[currentChange.idx] }
    );
    localSelectedChannelBanner = addNewChannelBannerRow({ selectedChannelBannerArg: localSelectedChannelBanner });
    currentChange.field = 'BannerImageDONE'
    setChannelBanner(localSelectedChannelBanner)
  }
  useEffect(
    () => {
      if (currentChange.field === 'BannerImage' || currentChange.field === 'BannerMessage') {
        setCombinationInfo1()
      }
    },
    [channelBanner]
  )
  const changeImage = (fileType: any) => {
    setOpenFile({
        currentFileSrc: selectedChannel?.Configurations?.ChannelLogo,
        folder: 'SalesChannel',
      type: fileType
    })
  }
const back=()=>{
  navigate('/management/organization/organization-management/channels')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <ChannelComponent 
          back={back}
          handleFormSubmit={handleFormSubmit}
          handleChannelBannerItemChange={handleChannelBannerItemChange}
          channelBanner={channelBanner}
          changeBannerImage={changeBannerImage}
          changeImage={changeImage}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          onInnerFormChange={handleInnerFormChange}
           selectedChannel ={selectedChannel}
           stores={storeItems?.result?.items}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementChannel;